module.exports = __webpack_public_path__ + "static/media/IMG_6292.985b1129.JPG";